module.exports = __webpack_public_path__ + "static/media/599.7554(27).2f878f4a.pdf";